import React from "react";

const ViewReceipt = ({
  id,
  viewReceiptOpen,
  closeViewReceipt,
  singleTransaction,
}) => {
  const documentUrl =
    singleTransaction?.document_url || singleTransaction?.payment_document_url;

  const handleDownload = () => {
    if (!documentUrl) return;

    const fileName = documentUrl?.split("/")?.pop() || "receipt";

    const link = document?.createElement("a");
    link.href = documentUrl;
    link.setAttribute("download", fileName);
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <>
      <div
        id={id}
        className={`${
          viewReceiptOpen ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="flex items-center justify-center w-full">
          <div className="relative bg-white shadow w-[60%] mx-auto rounded-lg">
            <div className="">
              <div className="bg-[#E8FBFF] w-full rounded-t-lg">
                <div
                  onClick={closeViewReceipt}
                  className="absolute right-[0px] cursor-pointer text-[24px] w-[40px] h-[40px] top-[0px] flex items-center justify-center"
                >
                  x
                </div>
                <div className="h-[134px] w-full flex flex-col justify-center">
                  <p className="text-[#005C53] mb-[10px] text-[20px] text-center">
                    {singleTransaction?.public_id ||
                      singleTransaction?.payment_code}
                  </p>
                  <div className="flex items-center justify-center gap-[40px]">
                    <div className="flex items-center gap-[10px]">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="19"
                        viewBox="0 0 16 19"
                        fill="none"
                      >
                        <path
                          d="M14.75 16.8612L2 9.5L14.75 2.13879L14.75 16.8612Z"
                          stroke="#FF3232"
                          strokeWidth="2"
                        />
                      </svg>
                      <p className="text-[#000] text-[14px]">
                        Reverse transaction
                      </p>
                    </div>
                    <div className="flex items-center gap-[10px]">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M12.36 6L12.76 8H18V14H14.64L14.24 12H7V6H12.36ZM14 4H5V21H7V14H12.6L13 16H20V6H14.4"
                          fill="#FFD00E"
                        />
                      </svg>
                      <p className="text-[#000] text-[14px]">
                        Flag transaction
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-col items-center justify-center mt-5 px-8 mb-20">
                <div className="flex w-[75%] mt-[10px]">
                  <p className="text-[#000000] w-[35%] font-bold text-[15px]">
                    Receipt
                  </p>
                  <p className="text-[#06B217] w-[50%] text-[15px] truncate">
                    {documentUrl
                      ? documentUrl?.split("/")?.pop()?.slice(-31)
                      : ""}
                  </p>
                </div>

                <div className="p-3 mt-5 w-[75%] border-[1px] border-[#DFDFDF] max-h-[45vh] overflow-y-auto">
                  {documentUrl ? (
                    documentUrl?.toLowerCase()?.endsWith(".pdf") ? (
                      <iframe
                        src={`https://docs.google.com/gview?url=${encodeURIComponent(
                          documentUrl
                        )}&embedded=true`}
                        title="Receipt PDF"
                        className="w-full"
                        style={{ minHeight: "500px" }}
                      />
                    ) : (
                      <img src={documentUrl} alt="Receipt" className="w-full" />
                    )
                  ) : (
                    <span className="text-[#005C53] text-[16px] font-[500] text-center block">
                      No Receipt Available
                    </span>
                  )}
                </div>

                <div
                  onClick={handleDownload}
                  className="flex items-center justify-center mt-8 gap-2 cursor-pointer"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.25 15V17.5H3.75V15H2.5V17.5C2.5 17.8315 2.6317 18.1495 2.86612 18.3839C3.10054 18.6183 3.41848 18.75 3.75 18.75H16.25C16.5815 18.75 16.8995 18.6183 17.1339 18.3839C17.3683 18.1495 17.5 17.8315 17.5 17.5V15H16.25ZM16.25 8.75L15.3687 7.86875L10.625 12.6062V1.25H9.375V12.6062L4.63125 7.86875L3.75 8.75L10 15L16.25 8.75Z"
                      fill="#06B217"
                    />
                  </svg>
                  <p className="text-[#000000] font-[300] text-[14px]">
                    Download document
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewReceipt;
